<template>
    <div :id="target" class="modal fade" tabindex="-1" ref="modal">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-ums">
                    <h5 class="modal-title">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-body">
                                    <select2 :options="msgTypeOptions" v-model="msgType" :default-option="false" :vertical="true" :label="'msgType'"/>
                                    <select2 :options="languageOptions" v-model="lang" :default-option="false" :vertical="true" :label="'Language'"/>
                                    <basic-file-input ref="send" :vertical="true" :rule="'required fileType:csv'" accept=".csv" description="csv file only" @change="changeFile" :label="'File'"
                                                      downloadName="download sample csv file" downloadLocation="/assets/document/bulkMessageSend_sample.csv"/>
                                    <button class="btn bg-ums" style="width: 100%" @click="send" v-if="hasRole($const.ROLES.EVENT_BULK_SEND)">Send</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicFileInput from "@/components/form/input/BasicFileInput";
    import Select2 from "@/components/form/select/Select2";
    import validation from "@/config/mixin/validation";
    import api from '@/api/template'

    export default {
        name: "BulkSendModal",
        components: {
            BasicFileInput,
            Select2
        },
        mixins:[validation],
        props: {
            target: {
                type:String,
                required: true
            },
            eventInfo: {
                type:Object
            },
        },
        data() {
            return {
                file:null,
                lang:'ID',
                msgType: '1',
                modalWidth: window.innerWidth - 500,
                modalHeight: window.innerHeight - 150,
            }
        },
        created() {
            window.addEventListener('resize', () => {
                this.resizeHandler()
            });

        },
        mounted() {
            if (!$().uniform) {
                console.warn('Warning - uniform.min.js is not loaded.');
                return;
            }

            // File input
            $('.form-control-uniform').uniform();

            // Custom select
            $('.form-control-uniform-custom').uniform({
                fileButtonClass: 'action btn bg-blue',
                selectClass: 'uniform-select bg-pink-400 border-pink-400'
            });

            /*let that = this
            $(this.$refs.modal).on("hidden.bs.modal", function (){
                // that.reset()
            })
*/
        },
        computed: {
            languageOptions: function() {
                return this.$store.getters[this.$const.GETTERS.LANGUAGE_OPTIONS]()
            },
            msgTypeOptions: function() {
                return this.$store.getters[this.$const.GETTERS.MSG_TYPE_OPTIONS]()
            },
            title: function() {
              return this.eventInfo.queueType === 'R'? 'Regular Message Send Modal' : 'Bulk Message Send Modal'
            },

        },

        methods: {
            resizeHandler: function() {
                this.modalHeight = window.innerHeight - 300
                this.modalWidth = window.innerWidth -150
            },
            send:function() {
                if(!this.validationCheck()) return;
                if(!this.eventInfo.clientCd || !this.eventInfo.eventId) return;
                api.bulkMessageSend(this.eventInfo.clientCd,this.eventInfo.eventId,this.msgType,this.lang,this.file).then((result)=>{
                    if(result && result.data.code === 1000) {
                        this.$notify.success(result.data.message)
                        $('#'+this.target).modal('toggle')
                    }
                })
            },
            changeFile: function(file) {
                this.file = file
            },
            // reset: function () {
            //   console.log("---modal.reset call---")
            //   this.lang = 'ID'
            //   this.msgType = '1'
            //   this.$refs.send.reset()
            //
            // }
        },
        watch: {
            eventInfo: function(val) {
                console.log(val)
            },
        }
    }
</script>

<style scoped>
    .modal-header .close {
        top:4% !important;
    }
    .modal-header {
        padding: 9px 19px !important;
    }
</style>
